(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("js-cookie"), require("object-hash"), require("axios"));
	else if(typeof define === 'function' && define.amd)
		define("index", ["js-cookie", "object-hash", "axios"], factory);
	else if(typeof exports === 'object')
		exports["index"] = factory(require("js-cookie"), require("object-hash"), require("axios"));
	else
		root["index"] = factory(root["js-cookie"], root["object-hash"], root["axios"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_7__, __WEBPACK_EXTERNAL_MODULE_9__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EnvironmentConfiguration = __webpack_require__(1);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Config = function Config() {
  _classCallCheck(this, Config);

  this.loginUrl = 'https://' + (0, _EnvironmentConfiguration.getPathForWebEnvironment)() + '.24hourfitness.com/login.html#/?redirect_uri=';
};

var cfg = new Config();
exports.default = cfg;
module.exports = exports['default'];

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var domain = window.location.hostname;

function _getEnvironment() {
  var subDomain = domain.replace('24hourfitness.com', '');
  switch (subDomain) {
    case 'webdev.':
      {
        return 'dev';
      }
    case 'webqa.':
      {
        return 'qa';
      }
    case '':
      {
        return 'prod';
      }
    case 'www.':
      {
        return 'prod';
      }
    default:
      {
        return 'dev';
      }
  }
}
//  For "webservices-dev" path styles
exports.getEnvironment = _getEnvironment;
function _getPathForEnvironment() {
  var env = _getEnvironment();
  if (env === 'prod') return '';else return '-' + env;
}

exports.getPathForEnvironment = _getPathForEnvironment;
function _getPathForWebEnvironment() {
  var env = _getEnvironment();
  if (env === 'prod') return '';else return 'web' + env;
}
exports.getPathForWebEnvironment = _getPathForWebEnvironment;

var PathSolver = function () {
  function PathSolver() {
    _classCallCheck(this, PathSolver);
  }

  _createClass(PathSolver, null, [{
    key: 'getPathForEnvironment',
    value: function getPathForEnvironment() {
      return _getPathForEnvironment();
    }
  }, {
    key: 'getPathForWebEnvironment',
    value: function getPathForWebEnvironment() {
      return _getPathForWebEnvironment();
    }
  }, {
    key: 'getEnvironment',
    value: function getEnvironment() {
      return _getEnvironment();
    }
  }]);

  return PathSolver;
}();

exports.default = PathSolver;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StringUtils = exports.STATE_LIST = exports.commonCfg = exports.cachiosConfigure = exports.PathSolver = exports.SessionCache = exports.cachiosFactory = exports.AuthService = undefined;

var _AuthService = __webpack_require__(3);

var _AuthService2 = _interopRequireDefault(_AuthService);

var _cachios = __webpack_require__(5);

var _cachios2 = _interopRequireDefault(_cachios);

var _axiosConfigurer = __webpack_require__(8);

var _axiosConfigurer2 = _interopRequireDefault(_axiosConfigurer);

var _sessionCache = __webpack_require__(10);

var _sessionCache2 = _interopRequireDefault(_sessionCache);

var _EnvironmentConfiguration = __webpack_require__(1);

var _EnvironmentConfiguration2 = _interopRequireDefault(_EnvironmentConfiguration);

var _commonUrl = __webpack_require__(0);

var _commonUrl2 = _interopRequireDefault(_commonUrl);

var _StringUtils = __webpack_require__(11);

var _StringUtils2 = _interopRequireDefault(_StringUtils);

var _Constants = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.AuthService = _AuthService2.default;
exports.cachiosFactory = _cachios2.default;
exports.SessionCache = _sessionCache2.default;
exports.PathSolver = _EnvironmentConfiguration2.default;
exports.cachiosConfigure = _axiosConfigurer2.default;
exports.commonCfg = _commonUrl2.default;
exports.STATE_LIST = _Constants.STATE_LIST;
exports.StringUtils = _StringUtils2.default;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Cookies = __webpack_require__(4);

var AuthService = function () {
  function AuthService() {
    _classCallCheck(this, AuthService);
  }

  _createClass(AuthService, [{
    key: 'getAuthToken',
    value: function getAuthToken() {
      return Cookies.get('securityToken');
    }
  }, {
    key: 'logOut',
    value: function logOut() {
      Cookies.remove('securityToken');
    }
  }, {
    key: 'isLoggedIn',
    value: function isLoggedIn() {
      var tok = this.getAuthToken();
      return tok !== undefined;
    }
  }]);

  return AuthService;
}();

exports.default = AuthService;
module.exports = exports['default'];

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Cachios = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extendPrototype = __webpack_require__(6);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var objectHash = __webpack_require__(7);

function defaultCacheIdentifer(config) {
  return {
    method: config.method,
    url: config.url,
    params: config.params,
    data: config.data
  };
}

function defaultResponseCopier(response) {
  return {
    status: response.status,
    data: response.data,
    $ttl: Math.floor(Date.now() / (1000 * 60))
  };
}

var Cachios = function () {
  function Cachios(axiosInstance, cacheConfig) {
    _classCallCheck(this, Cachios);

    this.cacheConfig = cacheConfig;
    this.sessionCache = this.cacheConfig.sessionCache;
    this.axiosInstance = axiosInstance;
    this.getCacheIdentifier = defaultCacheIdentifer;
    this.getResponseCopy = defaultResponseCopier;
  }

  _createClass(Cachios, [{
    key: 'getCacheKey',
    value: function getCacheKey(config) {
      return this.sessionCache.getCacheKey(objectHash(this.getCacheIdentifier(config)));
    }
  }, {
    key: 'getCachedValue',
    value: function getCachedValue(cacheKey) {
      return JSON.parse(this.sessionCache.getCachedValue(cacheKey));
    }
  }, {
    key: 'setCachedValue',
    value: function setCachedValue(cacheKey, value) {
      this.sessionCache.setCachedValue(cacheKey, JSON.stringify(value));
    }
  }, {
    key: 'request',
    value: function request(config) {
      var _this = this;

      var useCache = config.useCache;
      if (!useCache) {
        return this.axiosInstance.request(config);
      }
      if (config.refresh) {
        var _cacheDataKey = this.getCacheKey(config);
        this.sessionCache.removeItem(_cacheDataKey);
      }

      var cacheDataKey = this.getCacheKey(config);
      var cachedValue = this.getCachedValue(cacheDataKey);

      if (cachedValue !== null) {
        var time = cachedValue.$ttl;
        var currentTime = Math.floor(Date.now() / (1000 * 60));
        var elapsed = currentTime - time;
        var ttlTime = config.ttl || this.cacheConfig.ttl;
        if (elapsed > ttlTime) {
          this.sessionCache.removeItem(cacheDataKey);
          cachedValue = null;
        }
      }

      var promise = void 0;
      if (cachedValue === null) {
        promise = this.axiosInstance.request(config).then(function (resp) {
          _this.setCachedValue(cacheDataKey, _this.getResponseCopy(resp));
          return resp;
        });
      } else {
        promise = Promise.resolve(cachedValue);
      }

      return promise;
    }
  }]);

  return Cachios;
}();

(0, _extendPrototype.extendPrototype)(Cachios.prototype);
exports.Cachios = Cachios;

var instance = {};

instance.create = function create(axiosInstance, cacheKey) {
  return new Cachios(axiosInstance, cacheKey);
};
exports.default = instance;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var datalessMethods = ['delete', 'get', 'head', 'options'];

var dataMethods = ['post', 'put', 'patch'];

function extendPrototype(cachiosPrototype) {
  datalessMethods.forEach(function (method) {
    cachiosPrototype[method] = function aliasDatalessMethod(url, config) {
      var baseRequest = {
        url: url,
        method: method
      };

      var mergedRequest = Object.assign(config || {}, baseRequest);

      return this.request(mergedRequest);
    };
  });

  dataMethods.forEach(function (method) {
    cachiosPrototype[method] = function aliasDataMethod(url, data, config) {
      var baseRequest = {
        url: url,
        method: method,
        data: data
      };

      var mergedRequest = Object.assign(config || {}, baseRequest);

      return this.request(mergedRequest);
    };
  });
}
exports.extendPrototype = extendPrototype;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_7__;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createInstance;

var _commonUrl = __webpack_require__(0);

var _commonUrl2 = _interopRequireDefault(_commonUrl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var axios = __webpack_require__(9);

function createInstance(authService, cacheConfig, cachios) {
  var axiosInstance = axios.create({});

  axiosInstance.interceptors.request.use(function (config) {
    config.headers['Authorization'] = authService.getAuthToken();
    return config;
  }, function (error) {
    return Promise.reject(error);
  });

  axiosInstance.interceptors.response.use(function (response) {
    return response;
  }, function (error) {
    if (error.response.status === 401) {
      authService.logOut();
      var currentUrl = document.URL;
      window.location.href = _commonUrl2.default.loginUrl + encodeURIComponent(currentUrl);
    }
    return Promise.reject(error);
  });

  return cachios.create(axiosInstance, cacheConfig);
}
module.exports = exports['default'];

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_9__;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SessionCache = function () {
  function SessionCache(authService, cacheConfig) {
    _classCallCheck(this, SessionCache);

    this.cacheConfig = cacheConfig;
    this.cacheKey = this.cacheConfig.key;
    this.authService = authService;
  }

  _createClass(SessionCache, [{
    key: 'getCachedValue',
    value: function getCachedValue(key) {
      var currentToken = this.authService.getAuthToken();
      var currTok = this.getCurrentUserToken();
      if (currTok !== currentToken) {
        this.clearCache();
        this.setCurrentUserToken(currentToken);
        return null;
      }
      return this._getCachedValue(key);
    }
  }, {
    key: 'getCacheKey',
    value: function getCacheKey(key) {
      return this.cacheKey + '-' + key;
    }
  }, {
    key: 'getCurrentUserToken',
    value: function getCurrentUserToken() {
      return sessionStorage.getItem(this.cacheKey + '-securityToken');
    }
  }, {
    key: 'setCurrentUserToken',
    value: function setCurrentUserToken(token) {
      sessionStorage.setItem(this.cacheKey + '-securityToken', token);
    }
  }, {
    key: '_getCachedValue',
    value: function _getCachedValue(cacheKey) {
      return sessionStorage.getItem(cacheKey);
    }
  }, {
    key: 'setCachedValue',
    value: function setCachedValue(cacheKey, value) {
      return sessionStorage.setItem(cacheKey, value);
    }
  }, {
    key: 'removeItem',
    value: function removeItem(key) {
      sessionStorage.removeItem(key);
    }
  }, {
    key: 'clearCache',
    value: function clearCache() {
      var valuesToDelete = [];
      for (var i = 0; i < sessionStorage.length; i++) {
        var key = sessionStorage.key(i);
        if (key.indexOf(this.cacheKey) === 0) {
          valuesToDelete.push(key);
        }
      }
      valuesToDelete.forEach(function (t) {
        return sessionStorage.removeItem(t);
      });
    }
  }]);

  return SessionCache;
}();

exports.default = SessionCache;
module.exports = exports['default'];

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StringUtils = function () {
  function StringUtils() {
    _classCallCheck(this, StringUtils);
  }

  _createClass(StringUtils, null, [{
    key: "initCaps",
    value: function initCaps(string) {
      return string.toLowerCase().replace(/(?:^|\s)[a-z]/g, function (m) {
        return m.toUpperCase();
      });
    }
  }]);

  return StringUtils;
}();

exports.default = StringUtils;
module.exports = exports["default"];

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var STATE_LIST = ['AL', 'AK', 'AS', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FM', 'FL', 'GA', 'GU', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MH', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'MP', 'OH', 'OK', 'OR', 'PW', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VI', 'VA', 'WA', 'WV', 'WI', 'WY'];
exports.STATE_LIST = STATE_LIST;

/***/ })
/******/ ]);
});
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/my-account-common/dist/index.js
// module id = OrvR
// module chunks = 0